import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import { z } from 'zod'
dayjs.extend(weekOfYear)

export const Prd3110SearchParamsSchema = z
  .object({
    stationId: z.string().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Prd3110SearchParams = z.infer<typeof Prd3110SearchParamsSchema>

export const Prd3110SearchResultModelSchema = z.object({
  id: z.number(),
  date: z.coerce.date(),
  stationId: z.number(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  operatorId: z.string(),
  isFetched: z.boolean(),
})

export type Prd3110SearchResultModel = z.infer<
  typeof Prd3110SearchResultModelSchema
>

export const Prd3110SearchResultSchema = z
  .object({
    data: z.array(Prd3110SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Prd3110SearchResult = z.infer<typeof Prd3110SearchResultSchema>
